// Internal DriverWatch Admin Portal - Login Page
// Only DriverWatch staff can access this portal

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../config";

const API_URL = config.API_URL;

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const formData = new URLSearchParams();
      formData.append("username", email);
      formData.append("password", password);

      const response = await axios.post(`${API_URL}/internal/login`, formData, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      });

      sessionStorage.setItem("internal_token", response.data.access_token);
      sessionStorage.setItem("internal_user", JSON.stringify(response.data.user));

      navigate("/");

    } catch (err) {
      setError("Invalid email or password. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center">
      <div className="w-full max-w-md">

        {/* Logo and title */}
        <div className="text-center mb-8">
          <img src="/logo-white.png" alt="AleroSys" className="h-16 mx-auto mb-4" />
          <p className="text-gray-400 mt-1 text-sm">by Alero Systems LLC</p>
          <p className="text-gray-500 mt-2 text-sm">DriverWatch — Internal Admin Portal</p>
        </div>

        {/* Login form */}
        <div className="bg-gray-900 rounded-2xl p-8 border border-red-900">

          {error && (
            <div className="bg-red-900 border border-red-700 text-red-300 px-4 py-3 rounded-lg mb-6 text-sm">
              {error}
            </div>
          )}

          <form onSubmit={handleLogin}>

            <div className="mb-5">
              <label className="block text-gray-400 text-sm mb-2">Email address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@alerosys.com"
                className="w-full bg-gray-800 border border-gray-700 text-white rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-red-500 transition-colors"
                required
              />
            </div>

            <div className="mb-6">
              <label className="block text-gray-400 text-sm mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full bg-gray-800 border border-gray-700 text-white rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-red-500 transition-colors"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "Signing in..." : "Sign in"}
            </button>

          </form>
        </div>

        <p className="text-center text-gray-600 text-sm mt-6">
          AleroSys · DriverWatch Internal Portal · Authorized Access Only
        </p>

      </div>
    </div>
  );
}